const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0xF4C9ad4cf3595ddaCDe89B6dE8d7cf8d948dA9DB',
  busdAddress: '0x9a00EbF48666227e87bf2E1951823666CD3D474e',
  lpAddress: '0xF7CeFFD80079E23aAEA2FFf945d74d902719765A'
}

export default priceContracts